export const OPEN_ADD_POST_DIALOG = 'OPEN_ADD_POST_DIALOG';

export function openAddPostDialog() {
  return {
    type: OPEN_ADD_POST_DIALOG,
  };
}



// WEBPACK FOOTER //
// ./app/features/newCommunityPost/actions/openAddPostDialog.js